import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { config } from "../../configuration/app/app-config"
import { accessToken } from "../../configuration/token/accessToken"
import { agreementListSchema } from "./agreeementApi.model"
import { toAgreement } from "./agreementApi.converter"
import { Agreement } from "../../model/agreement/agreement"

const url = config.agreementApi.baseUrl

const GET_AGREEMENTS_API_TAG = "GET_AGREEMENTS"

export const agreementApi = createApi({
    reducerPath: "agreementApi",
    tagTypes: [GET_AGREEMENTS_API_TAG],
    baseQuery: fetchBaseQuery({
        baseUrl: url,
        prepareHeaders: (headers) => {
            headers.set("authorization", `Bearer ${accessToken.getAccessToken()}`)
            headers.set("accept", "application/json")
            return headers
        },
    }),
    endpoints: (builder) => ({
        getAgreements: builder.query<Agreement[], void>({
            query: () => "/agreements",
            transformResponse: (response: unknown) => {
                const agreements = agreementListSchema.parse(response)
                return agreements.items.map(toAgreement)
            },
            providesTags: [{ type: GET_AGREEMENTS_API_TAG }],
        }),
        putAgreement: builder.mutation<void, { id: string }>({
            query: (agreement) => ({
                url: `/agreements/${agreement.id}`,
                method: "PUT",
                body: {
                    id: agreement.id,
                },
            }),
            invalidatesTags: [{ type: GET_AGREEMENTS_API_TAG }],
        }),
    }),
})

export const {
    useGetAgreementsQuery,
    usePutAgreementMutation,
} = agreementApi
